import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FrequencyPending } from '../interfaces/freuencyPending';

@Component({
  selector: 'app-frequency-card',
  templateUrl: './frequency-card.component.html',
  styleUrls: ['./frequency-card.component.css'],
})
export class FrequencyCardComponent implements OnInit {
  @Input() frequency: FrequencyPending;

  constructor(private router: Router) {
    console.log(this.frequency);
  }

  ngOnInit(): void {}

  startFrequency(groupWordId: string, groupId: string) {
    this.router.navigate(['frequencia/add'], {
      queryParams: { groupWordId, groupId },
    });
  }
}
